import * as actionTypes from "../../constants/ActionTypes/HardwareInclusive/HardwareInclusive";

const initialState = {
    allServicePlan: {},
    loading: false,
    error: "",
    success: false,
}

const GetHWServicePlan = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_HW_SERVICE_PLAN:
            return {
                ...state,
                loading: true,
                success: false,
                error: "",
                allServicePlan:{}
            };
        case actionTypes.GET_HW_SERVICE_PLAN_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: "",
                allServicePlans: action.servicePlan,
            };
        case actionTypes.GET_HW_SERVICE_PLAN_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                allServicePlan:{}
            };
        case actionTypes.GET_HW_PRINTER_BY_FEATURES_RESET:
            return {
                ...state,
                success: false,
                error: "",
                allServicePlan:{}
            };
        default:
            return {...state};
    }
}

export default GetHWServicePlan;